import { getAlignImage } from '../../image-alignment';
export default function (a) {
  var b,
      c = 'top',
      d = 'middle',
      e = 'bottom',
      f = 'left',
      g = 'right',
      h = function h(a) {
    return function () {
      a.hide();

      for (var _b = 0, _c = a._.gridElem && a._.gridElem.length; _b < _c; _b++) {
        a._.gridElem[_b].remove();
      }

      a._.gridElem = [], a._attr({
        src: a._._src
      }), setTimeout(function () {
        a.show();
      }, 100);
    };
  },
      i = function i(a, c, d) {
    return function () {
      var e,
          f,
          g,
          h = j(a._.imageGridAttr, c),
          i = 1,
          k = 1,
          l = 1;

      if (h.tileInfo && (i = h.tileInfo.xCount, k = l = h.tileInfo.yCount, g = h.y, delete h.tileInfo), a._.gridElem) {
        for (f = 0; f < a._.gridElem.length; f++) {
          a._.gridElem[f].remove();
        }

        a._.gridElem.length = 0;
      }

      for (f = 0; i && h.width && h.height;) {
        l--, 0 === f ? a.attr(d ? Object.assign(h, {
          applysrc: a._._src
        }) : h) : (e = a.clone().attr({
          x: h.x,
          y: h.y
        }), a._.gridElem.push(e.follow(a, b, 'after'))), h.y += h.height, 0 === l && (l = k, i--, h.x += h.width, h.y = g), f++;
      }
    };
  },
      j = function j(a, b) {
    var c;

    if (a) {
      var _d = a.displayMode,
          _e = a.vAlign,
          _f = a.hAlign,
          _g = a.scale,
          _h = a.canvasBorderWidth,
          _i = a.canvasWidth,
          _j = a.canvasHeight,
          k = b.width * (_g / 100),
          l = b.height * (_g / 100);
      c = getAlignImage(_e, _f, _d, k, l, _i, _j, _h, _i - 2 * _h, _j - 2 * _h);
    }

    return c || {
      x: 0,
      y: 0,
      width: b.width,
      height: b.height
    };
  };

  a.define && a.define([{
    name: 'imagegrid',
    imagegrid: function imagegrid() {
      var c,
          d,
          e = this,
          f = arguments,
          g = f.length - 1,
          j = f[g];
      return j && j.constructor === a.el.constructor ? f[g] = b : j = b, c = new Image(), d = e.image(j), d._.gridElem = [], d._.refImage = c, d._attr = d.attr, d.attr = function (a, c) {
        var e = Array.isArray(a),
            f = !e && 'object' == typeof a,
            g = 'string' == typeof a;

        if (e && (a = a[0], f = 'object' == typeof a), f) {
          var _b2 = Object.assign({}, a),
              _c2 = _b2 && _b2.src,
              _e2 = _b2 && _b2.applysrc;

          delete _b2.src, delete _b2.applysrc, _c2 && delete d._._src, d._attr(_b2), _c2 && d._attr({
            _src: _c2
          }), _e2 && d._attr({
            src: _e2
          });
        } else {
          if (a === b && c === b) return this.attrs;
          if (c === b) return this.attrs[a];
          g && c && ('src' === a ? d._attr({
            _src: c
          }) : 'applysrc' === a ? d._attr({
            src: c
          }) : d._attr({
            name: c
          }));
        }

        return this;
      }, c.onload = i(d, c, !0), c.onerror = h(d), d;
    },
    ca: {
      imagegrid: function imagegrid(a, b, h) {
        var j = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
        var k = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        var m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var n = this;
        a === 'tile' || a === 'fill' || a === 'fit' ? (b !== c && b !== d && b !== e && (b = d), h !== f && h !== d && h !== g && (h = d)) : (b !== c && b !== d && b !== e && (b = c), h !== f && h !== d && h !== g && (h = f)), n._.imageGridAttr = {
          displayMode: a,
          vAlign: b,
          hAlign: h,
          scale: j,
          canvasBorderWidth: k,
          canvasWidth: l,
          canvasHeight: m
        }, this._._src && i(n, n._.refImage)();
      },
      _src: function _src(a) {
        return this._.refImage.src = a, this._._src = a, {
          _src: a
        };
      }
    }
  }]);
}